import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

// Import styles
import { transitionMain, customMinResponsive, size } from 'components/styles';

export const StyledLink = styled(Link)`
	color: ${({ theme }) => theme.blueAzureDark};
	cursor: pointer;
	${transitionMain}
	font-size: 2.5rem;

	&:hover {
		color: ${({ theme }) => theme.white};
	}
`;

export const Comma = styled.span`
	color: ${({ theme }) => theme.blueAzureDark};
	font-size: 2.5rem;
`;

export const ButtonWrapper = styled.div`
	width: 22rem;
	margin: 0 auto;

	${customMinResponsive(
		size.semi,
		css`
			width: auto;
		`
	)}
`;
